import { GET_PLC_SAFETY_TRIGGERS, GET_PLC_SAFETY_TRIGGERS_SUCCESS, GET_PLC_SAFETY_TRIGGERS_ERROR } from './actionTypes';

export const getPlcSafetyTriggers = (user) => ({
  type: GET_PLC_SAFETY_TRIGGERS,
  payload: { user },
});

export const getPlcSafetyTriggersSuccess = (triggers) => ({
  type: GET_PLC_SAFETY_TRIGGERS_SUCCESS,
  payload: { triggers },
});

export const getPlcSafetyTriggersError = (error) => ({
  type: GET_PLC_SAFETY_TRIGGERS_ERROR,
  payload: error,
});
